import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@app/_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
            }
          if (err.status === 422) {
            let error = "";
            Object.keys(err.error).forEach(prop => {
              error = error == "" ? err.error[prop][0] : error + "<br/>" + err.error[prop][0]
            });
            console.log(error)
            return throwError(error);
          } else {
            console.log(err);
            const error = err.error.message || err.statusText;
            console.log(error)
            return throwError(error);
          }
        }))
    }
}
